<template>
  <DropdownMenu class="text-text-brand" :show-chevron="true">
    <span class="flex flex-row items-center gap-xs">
      <FontAwesomeIcon icon="fa-regular fa-headset" size="lg" />
      <span class="font-base">{{ authStore.name }}</span>
    </span>
    <template #dropdown>
      <MenuItem v-on:click="logOut()"
        ><FontAwesomeIcon
          class="text-text-brand"
          icon="fa-regular fa-right-from-bracket"
          size="lg"
        /><span class="text-text-brand">Logga ut</span></MenuItem
      >
    </template>
  </DropdownMenu>
</template>
<script setup lang="ts">
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faFolderOpen,
  faHeadset,
  faRightFromBracket,
} from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

import DropdownMenu from "@/components/ui/DropdownMenu.vue";
import MenuItem from "@/components/ui/MenuItem.vue";
import { useAuthStore } from "@/stores/authStore";

const authStore = useAuthStore();

library.add(faHeadset, faFolderOpen, faRightFromBracket);

function logOut() {
  authStore.logout();
}
</script>
